<template>
    <div class="shopPageWrapper">
        <div class="mainContent">
            <div class="singleSection" id="singleSectionBigContact">
                <img 
                    class="backgroundImgTwo"
                    :src="require('./../assets/shopLanding/backgroundImage.png')" 
                    alt=""
                >
                <div class="sectionBody">
                    <contactSection />
                </div>
            </div>
        </div>
        <div style="width: 100%"><iframe width="100%" height="500" src="https://maps.google.com/maps?q=58.159887, 26.090716&output=embed"></iframe></div>
    </div>
</template>
  
<script>
import contactSection from '../components/shopLanding/contactSection.vue'

export default {
    name: 'contactPage',
    components: {
        contactSection,
    },
    props: {
        idShop: {},
        shopData: {},
        shopPageUrl: {},
        feedbacksData: {},
        feedbackStatsData: {},
        listingData: {},
        listingsDataRaw: {},
        cardLoadingTime: {},
        counter: {},
        shippingProfileData: {},
    },
};
</script>
  
<style scoped>
.shopPageWrapper {
    position: relative;
    width: 100%;
}
.gMap{
    margin-top: 50px;
    margin-bottom: -5px;
    -webkit-box-shadow: 0px -15px 50px -30px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px -15px 50px -30px rgba(0,0,0,0.75);
    box-shadow: 0px -15px 50px -30px rgba(0,0,0,0.2);
}
.mainContent {
    margin: 0 auto;
}
.singleSection {
    position: relative;
    padding-top: 150px;
    padding-bottom: 50px;
}
.sectionBody {
    position: relative;
    width: 1300px;
    margin: 0 auto;
}
.backgroundImgTwo {
    position: absolute;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    z-index: 0;
    width: 700px;
    opacity: .18;
}
@media(max-width: 1340px) {
    .sectionBody {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }
    .singleSection {
        padding-top: 50px;
    }
}
@media (max-width: 500px) {
    .singleSection {
        padding-top: 10px;
    }
}
</style>
